import $ from "jquery";

export function hamburger() {
  //var siteHeader = "var(--site-header-height)";
  /* Hamburger */
  $(".site-header__hamburger-cta").click(function () {
    var siteHeader = $(".site-header").height();
    //$(".main-navigation-wrapper").css("top", siteHeader + "px");
    $(this).toggleClass("is-active");
    $(".main-navigation-wrapper").toggleClass(
      "main-navigation-wrapper--active",
    );
    //.toggleClass("main-navigation-wrapper--active").slideToggle(280, "swing");
    //$(".site-header__navigation").slideToggle();
    $("body").toggleClass("nav-active");

    if ($("body").hasClass("nav-active")) {
    } else {
      //$(".main-navigation-wrapper").css("top", "unset");
      //remove top css style
    }
  });
}
